import { render, staticRenderFns } from "./WeekAdd.vue?vue&type=template&id=307a2a37"
import script from "./WeekAdd.vue?vue&type=script&lang=js"
export * from "./WeekAdd.vue?vue&type=script&lang=js"
import style0 from "./WeekAdd.vue?vue&type=style&index=0&id=307a2a37&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports